// extracted by mini-css-extract-plugin
module.exports = {"badge":"e2ff468f85--badge--vmAVa"};